import { type HTMLAttributes, useState } from 'react';
import { Label } from '../ui/label';
import { Switch } from '../ui/switch';

export interface SwitchProps extends HTMLAttributes<HTMLButtonElement> {
	id: string;
	label?: string;
}

const FoundationSwitch = ({ id, label, ...rest }: SwitchProps) => {
	const [isChecked, setIsChecked] = useState<boolean>(false);

	return (
		<div className='wlcb-flex wlcb-items-center wlcb-space-x-2'>
			<Switch
				{...rest}
				onCheckedChange={() => setIsChecked(!isChecked)}
				checked={isChecked}
				id={id}
			/>
			{label ? (
				<Label
					style={{ color: 'var(--text-secondary)' }}
					className='wlcb-text-body wlcb-font-[400]'
					htmlFor={id}
				>
					{label}
				</Label>
			) : null}
		</div>
	);
};

export default FoundationSwitch;
